import {all, takeLatest} from 'redux-saga/effects';
import {releaseSaga, suspendSaga} from 'redux/common/saga/releaseSuspend';
import {sendTransactionSaga} from 'redux/transactions/sagas/sendTransaction';
import {updateTransactionSaga} from 'redux/transactions/sagas/updateTransaction';
import {openAndValidate} from 'redux/transactions/sagas/validate/openAndValidateSaga';
import {validate} from 'redux/transactions/sagas/validate/validateSaga';
import types from 'redux/transactions/types';

export function* transactionsSaga() {
   yield all([
      takeLatest(types.RELEASE_TRANSACTION.SAGA, releaseSaga),
      takeLatest(types.SUSPEND_TRANSACTION.SAGA, suspendSaga),
      takeLatest(types.OPEN_VALIDATE.SAGA, openAndValidate),
      takeLatest(types.VALIDATE_TRANSACTION.SAGA, validate),
      takeLatest(types.SEND_TRANSACTION.SAGA, sendTransactionSaga),
      takeLatest(types.UPDATE_TRANSACTION.SAGA, updateTransactionSaga),
   ]);
}
